import React, { useState } from 'react';

import { Dialog, DialogContent, Typography, Box, TextField, CircularProgress, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { useSnackbar } from 'notistack';

import { observationStatuses } from '../../constants/observations';
import QualityObservationService from '../../services/quality-observation.service';

const useStyles = makeStyles((theme) => ({
  buttonsContainer: {
    display: 'flex',
    gap: 8,
    justifyContent: 'center',
    marginTop: 40,
    padding: 8,
  },
  closeButton: {
    cursor: 'pointer',
    position: 'absolute',
    right: 10,
    top: 10,
  },
  confirmMessage: {
    marginTop: 8,
    textAlign: 'center',
  },
  dialog: {
    borderRadius: 8,
    width: 450,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 200,
    padding: '50px 40px 30px !important',
  },
  primaryButton: {
    borderRadius: 5,
    fontSize: 14,
    width: 180,
  },
  reasonField: {
    '& .MuiInputBase-root': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EBEBEB !important',
      boxShadow: 'none',
      height: 200,
      width: 370,
    },
    '& .MuiInputBase-root textarea': {
      height: '100% !important',
    },
    '& .MuiInputBase-root:hover': {
      border: '1px solid #EBEBEB !important',
    },
    '& .MuiInputBase-root:placeholder': {
      color: 'red',
    },
  },
  secundaryButton: {
    borderRadius: 5,
    fontSize: 14,
    width: 180,
  },
  subtitle: {
    color: '#172B4D',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 1.5,
    textAlign: 'center',
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 20,
    textAlign: 'center',
  },
}));

const CallBackObservationModal = ({ open, onClose, observationId }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [showReasonInput, setShowReasonInput] = useState(false);
  const [onHoldReason, setOnHoldReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResolve = async () => {
    try {
      setLoading(true);
      await QualityObservationService.complete(observationId);
      enqueueSnackbar('Observation marked as completed', { variant: 'success' });
      handleClose();
    } catch (error) {
      console.error('Error updating observation status:', error);
      enqueueSnackbar('Failed to update observation status', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleOnHold = () => {
    setShowReasonInput(true);
    setOnHoldReason('');
  };

  const handleReasonSubmit = async () => {
    if (!onHoldReason.trim()) {
      enqueueSnackbar('Please provide a reason for putting the observation on hold', { variant: 'warning' });
      return;
    }

    try {
      setLoading(true);
      await QualityObservationService.setOnHold(observationId, {
        onHoldReason: onHoldReason.trim(),
      });
      enqueueSnackbar('Observation put on hold', { variant: 'success' });
      handleClose();
    } catch (error) {
      console.error('Error updating observation status:', error);
      enqueueSnackbar('Failed to update observation status', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (close = true) => {
    setShowReasonInput(false);
    setOnHoldReason('');

    if (close) onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" classes={{ paper: classes.dialog }} PaperProps={{ style: { borderRadius: 12 } }}>
      <DialogContent aria-describedby="modal-description" className={classes.dialogContent}>
        <Typography variant="h5" className={classes.title}>
          {showReasonInput ? 'Reason for hold' : 'Video watched'}
        </Typography>

        <Close className={classes.closeButton} onClick={handleClose} title="Close" />

        <Typography variant="body1" className={classes.subtitle}>
          {showReasonInput ? (
            'Please write down the reason for hold:'
          ) : (
            <span>
              You have seen the video to the end please confirm <br /> this with the button bellow.
            </span>
          )}
        </Typography>

        {showReasonInput && (
          <TextField
            className={classes.reasonField}
            multiline
            minRows={6}
            variant="outlined"
            placeholder="Write the reasons here..."
            value={onHoldReason}
            onChange={(e) => setOnHoldReason(e.target.value)}
            disabled={loading}
          />
        )}

        <Box className={classes.buttonsContainer}>
          <Button onClick={() => (showReasonInput ? handleClose(false) : handleOnHold())} color="primary" variant="outlined" disabled={loading} className={classes.secundaryButton}>
            {showReasonInput ? 'Cancel' : 'On Hold'}
          </Button>

          <Button
            onClick={() => (showReasonInput ? handleReasonSubmit() : handleResolve())}
            color="primary"
            variant="contained"
            disabled={loading}
            className={classes.primaryButton}>
            {loading ? <CircularProgress size={24} /> : 'Done'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CallBackObservationModal;
